<moduurnv2-header-desktop></moduurnv2-header-desktop>
<div class="location-wrapper">
  <div class="location">
  
    <div class="loc-heading">
      <!-- {{ 'loc-heading' | translate }} <br /> -->
      <div class = "view-events" [ngClass]="{'view-events-Not-clicked': !viewEvents, 'view-events-clicked': viewEvents}" *ngIf = "yepDeskEvents == true" (click) = "showEvents()" >
    View Events
      </div>
    </div>
    <div class="search-bar">
      <div class="location-map-icon">
        <!-- <img [src]="locationPinIcon" alt="search map"/> -->
        <img src="/assets/images/search-icon.svg" alt="search icon"/>
      </div>
      <input
        type="text"
        [(ngModel)]="locationSearchQuery"
        placeholder="{{ locationSearchPlaceholder | translate }}"
        (keyup)="filterLocationByQuery()"
      />
      <img
        [src]="searchClose"
        *ngIf="locationSearchQuery"
        (click)="clearlocationSearch()"
        alt="clear search"
      />

      <!-- <div id="geocoder"></div> -->
    </div>
    <div class="loc-heading sub">
      {{ 'choose-store' | translate }}
    </div>
    <div *ngIf="isRestaurantsAvailable" class="loc-list-container">
      <div *ngIf="organizationLocations" class="loc-list custom-scroll">
        <ng-container
          *ngIf="
            organizationLocations && organizationLocations.length > 0;
            else locationsLoading
          "
        >
          <ng-container *ngFor="let location of organizationLocations">
            <div
              [ngClass]="{
                locationclick:
                  selectedLocation && location._id == selectedLocation._id,
                  imgincluded : showLocationImageFromConfig()
              }"
              class="location-cards"
              data-qa="card-location"
              aria-label="location on card"
              (click)="selectLocation(location);"
            >
            <div class="loc-image-outer" *ngIf="showLocationImageFromConfig()">
              <img
                *ngIf="location.imageUrl"
                src="{{ imageBaseUrl + location.imageUrl}}"
                alt="loc Image"
              />
            </div>
              <div class="card-wrapper" [class.cardextraspacing]="showLocationImageFromConfig()">
                <div class="loc-name">{{ location.name }}</div>
                <div class="location-status">
                  <span class="info-text">
                    <ng-container
                      *ngIf="
                        location.isLocationOpen && location.allow;
                        else closedLoc
                      "
                    >
                      <span class="open-status"> {{ 'Open' | translate }}</span>
                      <span class="open-till"> {{ 'Until' | translate }} </span>
                      <span class="open-till">
                        {{ location.openUntil | time24to12Transform }}</span
                      >
                    </ng-container>
                    <ng-template #closedLoc>
                      <ng-container *ngIf="location?.orderSettings?.futureOrder?.isAllow; else permClosed">
                        <span class="open-status"> {{ 'future-available' | translate }}</span>
                      </ng-container>
                      <ng-template #permClosed>
                        <span class="closed-status">
                          {{ 'Closed' | translate }}</span
                        >
                        <span class="closed-status" *ngIf="!location.isOpen">
                          {{ 'temporarily' | translate }}</span
                        >
                     </ng-template>
                    </ng-template>
                  </span>
                  <div
                    class="loc-distance"
                    *ngIf="location.distanceFromRequestedLocation"
                  >
                    {{ location.distanceFromRequestedLocation }}
                    {{ unitOfDistance | translate }} {{ 'away' | translate }}
                  </div>
                </div>
              </div>
              <img
                class="selectedTick"
                *ngIf="selectedLocation && location._id == selectedLocation._id"
                [src]="tickIcon"
                alt="selected icon"
              />
            </div>
          </ng-container>
        </ng-container>
        <ng-template #locationsLoading>
          <div class="location-loading"></div>
          <div class="location-loading"></div>
          <div class="location-loading"></div>
        </ng-template>
      </div>
    </div>
    <!-- Locations list -->
    <div class="no-data" *ngIf="!isRestaurantsAvailable">
      {{ 'no-resturants' | translate }}
    </div>
  </div>
  
<!--  -->
  <div class="eventlist"   *ngIf=" viewEvents == true; else selection" >
    <yepdesk-events-desktop></yepdesk-events-desktop> </div>
  <ng-template #selection>
    <div
    class="location-info hide-scroll"
    *ngIf="selectedLocation && isRestaurantsAvailable; else noSelection"
  >
    <div class="header">
      <!-- <img
        class="image-panel"
        *ngIf="selectedLocation.imageURL"
        [src]="selectedLocation.imageURL"
        alt="selected location"
      /> -->
      <img
        class="image-panel"
        *ngIf="selectedLocation.imageUrl && showLocationImageFromConfig()"
        src="{{ imageBaseUrl + selectedLocation.imageUrl}}"
        alt="selected location"
      />
      <div
        class="primary-details"
        [ngClass]="{ 'primary-details-withimg': showLocationImageFromConfig() }"
      >
        <div class="name">{{ selectedLocation.name }}</div>
        <div class="location-status">
          <span class="info-text">
            <!-- && location.allow -->
            <ng-container
              *ngIf="
                selectedLocation.isLocationOpen && selectedLocation.allow;
                else closedLoc
              "
            >
              <span class="open-status"> {{ 'Open' | translate }}</span>
              <span class="open-till"> {{ 'Until' | translate }} </span>
              <span class="open-till">
                {{ selectedLocation.openUntil | time24to12Transform }}</span
              >
            </ng-container>
            <ng-template #closedLoc>
              <ng-container *ngIf="selectedLocation?.orderSettings?.futureOrder?.isAllow; else permClosed">
                <span class="open-status"> {{ 'future-available' | translate }}</span>
              </ng-container>
              <ng-template #permClosed>
              <span class="closed-status"> {{ 'Closed' | translate }}</span>
              <span class="closed-status" *ngIf="!selectedLocation.isOpen">
                {{ 'temporarily' | translate }}</span>
              </ng-template>
            </ng-template>
          </span>
          <div class="address">{{ selectedLocation.address }}</div>
          <div>
            <span
              class="loc-distance"
              *ngIf="selectedLocation.distanceFromRequestedLocation"
              >{{ selectedLocation.distanceFromRequestedLocation }}
              {{ unitOfDistance | translate }} {{ 'away' | translate }}</span
            >
          </div>
        </div>
        <div class="contact">
          <div
            class="directions"
            (click)="
              getLocation(selectedLocation.loc[0], selectedLocation.loc[1])
            "
            data-qa="get-directions"
          >
            <img [src]="getDirection" class="icon" alt="direction"/>
            <span class="direction-text">{{
              'get-directions' | translate
            }}</span>
          </div>
          <div class="phone">
            <!-- <img [src]="phone" class="icon" alt="phone icon"/> -->
            <span class="info-text">{{ 'call-desktop' | translate }}</span>
            <a
              class="info-text"
              href="{{ 'tel:' + selectedLocation.businessPhoneNumber }}"
              >&nbsp;{{ selectedLocation.businessPhoneNumber }}</a
            >
          </div>
        </div>
      </div>
    </div>
    <div class="delivery">
      <span class="delivery-method">
        <ng-container
          *ngFor="
            let serviceType of selectedLocation.servicesSupported;
            let i = index
          "
        >
          {{ serviceType | translate }}
          <span *ngIf="i != selectedLocation.servicesSupported.length - 1"
            >,
          </span>
        </ng-container>
      </span>
      <span class="prep-time" *ngIf="selectedLocation.isLocationOpen && selectedLocation?.preprationTime && selectedLocation.preprationTime != '0 - 0'">
        <span class="pre-heading">{{ 'preparation-time' | translate }}</span
        ><br />{{ getPreparationTime(selectedLocation) }} mins</span
      >
    </div>

    <moduurnv2-location-operating-hours
      [location]="selectedLocation"
    ></moduurnv2-location-operating-hours>

    <div class="button-container">
      <!-- <button
        class="btn-submit order-later"
        (click)="futureOrderFromOrganization(selectedLocation)"
        data-qa="future-order"
        [disabled]="!selectedLocation?.orderSettings?.futureOrder?.isAllow"
        [ngClass]="{
          disabled: !selectedLocation?.orderSettings?.futureOrder?.isAllow
        }"
      >
        <span>{{ 'orderlater-desktop' | translate }}</span>
      </button>
      <button
        class="btn-submit order-now"
        (click)="orderNowFromLocation(selectedLocation)"
        [attr.data-qa]="'navigate-home-button-' + selectedLocation._id"
        [class.disabled]="!selectedLocation.isLocationOpen"
        [disabled]="
          !(
            !selectedLocation?.orderSettings?.asapOrder?.isAllow &&
            !selectedLocation?.orderSettings?.futureOrder?.isAllow
          ) && !selectedLocation?.orderSettings?.asapOrder?.isAllow
        "
        [ngClass]="{
          disabled:
            !(
              !selectedLocation?.orderSettings?.asapOrder?.isAllow &&
              !selectedLocation?.orderSettings?.futureOrder?.isAllow
            ) && !selectedLocation?.orderSettings?.asapOrder?.isAllow
        }"
      >
        <span>{{ 'order-desktop' | translate }}</span>
      </button> -->
      <button
        class="btn-submit loc-order"
        (click)="orderFromLocation(selectedLocation)"
        [attr.data-qa]="'navigate-home-button-' + selectedLocation._id"
      >
        <span>{{ 'order' | translate }}</span>
      </button>
    </div>
  </div>
</ng-template>

  <ng-template #noSelection
    ><div class="no-location">
      {{ 'nolocation-desktop' | translate }}
    </div></ng-template
  >
  <!-- <ng-template #noSelection
    ><div class="no-location">
      {{ 'nolocation-desktop' | translate }}
    </div></ng-template
  > -->
</div>
